export const skinCustom = {
  lightComponents: {
    body: '#ECEFF1',
    gradient: {
      gradientDefault1: '#C84B50',
      gradientDefault2: '#C84B50',
    },
  },
  darkComponents: {
    body: '#263238',
    gradient: {
      gradientDefault1: '#172260',
      gradientDefault2: '#000000',
    },
  },
}

export const image = {
  principal: 'http://seniorcertificados.com.br/image-bank/logobranca.png',
  favicon: 'http://seniorcertificados.com.br/image-bank/somentes.png',
}

export const seo = {
  titulo: 'Senior Contabilidade',
  email: 'bruno@datasenior.com.br',
  palavrasChave:
    'Certificado Digital, Cnpj a1, Cpf a1, emitir certificado, certificado curitiba',
  descricao:
    'Empresa líder em Certificação Digital, oferecendo soluções seguras e confiáveis para empresas e indivíduos, com ampla experiência no mercado.',
  descricaoPWA:
    'Certificados digitais são identidades eletrônicas seguras usadas para autenticar usuários, proteger informações e realizar transações online com segurança.',
}

export const header = {
  empresa: false,
  solucoes: false,
  contato: true,
  trabalheConosco: false,
  duvidasSuporte: true,
  parcerias: false,
  darkMode: false,
  contaLogin: true,
}

export const contentHome = {
  sispass: false,
  produtorRural: false,
  modalidadesCertificado: false,
}

export const footer = {
  is0800: false,
  telefone: '41 3336-7240',
  whatsapp: '41 3336-7240',
  botaoRenocao: '4133367240',
  comercial: '4133367240',
  botaoWhatsapp: '4133367240',
  number0800: '0800 600 2710',
  cidadeuf: 'Curitiba/PR',
  cidade: 'Curitiba',
  bairro: 'Mercês',
  titulo: 'Certificado Digital em Curitiba',
  rua: 'Rua Myltho Anselmo da Silva',
  numero: '1497',
  complemento: '',
  cep: '80810-060',
  cnpj: '',
  messageContador: 'Olá, tenho interesse em ser Parceiro Indicador.',
  messageRevenda: 'Olá, tenho interesse em revender Certificados Digitais',
  messageAgendamento: 'Olá, gostaria de agendar a emissão do meu Certificado',
  messageRenovacao: 'Olá, gostaria de renovar meu Certificado Digital',
  messageRenovacaoSispass:
    'Olá, gostaria de renovar meu Certificado Digital Sispass',
  messageConhecaNossasSolucoes:
    'Olá, gostaria de conhecer as soluções da Senior Contabilidade',
}

export const redes = {
  facebook: 'https://www.facebook.com/dataseniorcontabilidade/',
  instagram: 'https://www.instagram.com/seniorcontabilidade/',
  linkedin: 'https://www.linkedin.com/company/escrit%C3%B3rio-senior-contabilidade/',
}

export const digisac = {
  id: 'df7a6a14-269a-46ba-a874-33c45e74badf',
  status: false,
}

export const ratings = [
  {
    id: 1,
    descricao: 'Suporte e Atendimento excelentes!',
    author: 'Leonardo Lopes',
    ratingvalue: 5,
  },
  {
    id: 2,
    descricao:
      'Atendimento excelente. Super ágil, prático e simplificado! Ótima organização da equipe.',
    author: 'Tháliton Morais',
    ratingvalue: 5,
  },
  {
    id: 3,
    descricao: 'Atendimento do Suporte Técnico nota 10!.',
    author: 'Felipe Mourão',
    ratingvalue: 5,
  },
]
